import { render, staticRenderFns } from "./Stocks.vue?vue&type=template&id=3f0a1d0c&scoped=true&"
import script from "./Stocks.vue?vue&type=script&lang=js&"
export * from "./Stocks.vue?vue&type=script&lang=js&"
import style0 from "./Stocks.vue?vue&type=style&index=0&id=3f0a1d0c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f0a1d0c",
  null
  
)

export default component.exports